<template>
  <div style="height: calc(100vh - 120px);">
    <listToolbar :toolbar="toolbar" @addTap="addTap"/>
    <listTable
      :list="list"
      :loading="loading"
      :pageShow="false"
      :columns="columns" />
    <el-drawer v-model="formDrawerVisible" size="30%" :title="typeForm === 'add'? '添加' : '修改'">
      <div v-if="formDrawerVisible" style="padding-left: 16px; padding-right: 16px;">
        <Form :columns="addColumns" :type="typeForm" @submit="submit" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import listToolbar from '@/components/system/listToolbar.vue'
import { courseDel, courseList, courseSubmit, majorList } from '@/apis/common'
import listTable from '@/components/system/listTable.vue'
import Form from '@/components/system/form.vue'

export default {
  name: 'curriculum',
  components: { Form, listTable, listToolbar },
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('user')) || {},
      toolbar: [
        {type: 'button', label: '添加', def: 'primary',key: 'add'}
      ],
      loading: false,
      list: [],
      columns: [
        {label: '课程ID', prop: 'id', width: 100, type: 'text'},
        {label: '专业', prop: 'major_id', width: 100, type: 'json', deputy: 'major'},
        {label: '专业名称', prop: 'name', width: 100, type: 'text'},
        {label: '时长', prop: 'minute', width: 100, type: 'text'},
        {label: '操作', width: 100, type: 'but', arr: [
            {type: 'primary', icon: 'el-icon-edit', label: '修改', onClick: (row) => this.modify(row)},
            {type: 'danger', icon: 'el-icon-delete', label: '删除', onClick: (row) => this.del(row)},
          ]}
      ],
      formDrawerVisible: false,
      typeForm: 'add',
      addColumns: [
        {label: '课程名称', prop: 'name', type: 'input', value: ''},
        {label: '专业', prop: 'major_id', type: 'select', value: '',options: []},
        {label: '时长', prop: 'minute', type: 'input', value: ''},
      ],
    }
  },
  mounted() {
    this.getCourseList()
    this.getMajorList()
  },
  methods: {
    submit(e,v) {
      let form = {
        admin_id: this.info.id,
        course_id: v === 'edit' ? this.addFormData.id : '',
        agency_id: this.info.agency_school_id,
        school_id: 0,
        ...e
      }
      courseSubmit(form).then(r => {
        this.formDrawerVisible = false
        this.$message.success('操作成功')
        this.getCourseList()
      })
    },
    getMajorList() {
      majorList({
        page: 1,
        pagesize: 40,
        admin_id: this.info.id,
        is_all: 1
      }).then(res => {
        this.addColumns[1].options = res.data.data.list.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      })
    },
    del(e) {
      this.$confirm('是否删除该课程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        courseDel({
          admin_id: this.info.id,
          agency_id: this.info.agency_school_id,
          school_id: 0,
          course_id: e.id
        }).then(() => {
          this.getCourseList()
        }).catch(() => {})
      }).catch(() => {})
    },
    // 修改
    modify(row) {
      this.addFormData = row
      this.typeForm = 'edit'
      this.addColumns.forEach(item => {
        item.value = row[item.prop]
      })
      this.formDrawerVisible = true
    },
    addTap() {
      this.addColumns.forEach(item => {
        item.value = ''
      })
      this.formDrawerVisible = true
      this.typeForm = 'add'
    },
    getCourseList() {
      this.loading = true
      courseList({
        admin_id: this.info.id,
        agency_id: this.info.agency_school_id,
        school_id: this.info.school_id
      }).then(res => {
        this.loading = false
        this.list = res.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>
